import { Check } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const accentColors = [
  {
    id: 'emerald',
    label: 'Default',
    color: 'bg-emerald-500',
    description: 'Emerald green'
  },
  {
    id: 'blue',
    label: 'Ocean',
    color: 'bg-blue-500',
    description: 'Classic blue'
  },
  {
    id: 'purple',
    label: 'Purple',
    color: 'bg-purple-500',
    description: 'Royal purple'
  },
  {
    id: 'orange',
    label: 'Sunset',
    color: 'bg-orange-500',
    description: 'Warm orange'
  },
  {
    id: 'rose',
    label: 'Rose',
    color: 'bg-rose-500',
    description: 'Soft rose'
  },
  {
    id: 'mono',
    label: 'Mono',
    color: 'bg-zinc-500',
    description: 'Monochrome'
  },
];

export function AccentColorPicker() {
  const { accentColor, setAccentColor } = useTheme();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {accentColors.map(({ id, label, color, description }) => {
        const isSelected = accentColor === id;

        return (
          <button
            key={id}
            onClick={() => setAccentColor(id)}
            className={`relative flex items-center gap-3 p-3 rounded-lg border transition-all ${
              isSelected
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-muted-foreground/50 bg-card'
            }`}
          >
            <div className={`h-6 w-6 rounded-full ${color} flex-shrink-0`} />
            <div className="text-left min-w-0">
              <p className={`text-sm font-medium ${isSelected ? 'text-foreground' : 'text-muted-foreground'}`}>
                {label}
              </p>
              <p className="text-xs text-muted-foreground truncate">
                {description}
              </p>
            </div>
            {isSelected && (
              <div className="absolute top-2 right-2">
                <Check className="h-4 w-4 text-primary" />
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default AccentColorPicker;
